import {
  AnimationTriggerMetadata,
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

export function fadeInOutAnimation(
  timingIn: number = 300,
  timingOut: number = 200
): AnimationTriggerMetadata {
  return trigger('fadeInOut', [
    transition(':enter', [
      style({ opacity: 0.4 }),
      animate(timingIn, style({ opacity: 1 })),
    ]),
    transition(':leave', [animate(timingOut, style({ opacity: 0.4 }))]),
  ]);
}

export function valueChangedFadeInOut(): AnimationTriggerMetadata {
  return trigger('valueChangedFadeInOut', [
    transition('void => *', []),
    transition('* => void', []),
    transition('* => *', [
      animate(200, keyframes([style({ opacity: 0.5 }), style({ opacity: 1 })])),
    ]),
  ]);
}
